import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.css']
})
export class RatingComponent implements OnInit {
  @Input() rating!: number;
  @Input() avaliacoes: number = 0;
  @Input() maxRating: number = 5;
  @Output() click = new EventEmitter();
  ratings: Array<boolean> = [];

  constructor() { }

  ngOnInit(): void {

    this.rating = Math.round(this.rating);

    for (var star = 1; star <= this.maxRating; star++) {
      if (star <= this.rating) this.ratings.push(true)
      else this.ratings.push(false)
    }
  }

  getStyle(rating: boolean) {
    return {
      'fa-regular': !rating,
      'fa-solid': rating,
      'fa-star': true,
      'golden': true
    }
  }

}
